import styled from '@emotion/styled'

import { mediaUp } from '@/styles/media'

export const NavipayAdvertisementWrapper = styled.div`
  display: flex;
  width: 320px;
  padding: 32px 16px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border-radius: 12px;
  background: #f2f6fd;
  margin: 0 auto;
  ${mediaUp('md')} {
    width: 230px;
  }
  ${mediaUp('lg')} {
    width: 320px;
  }
`

export const NavipayTextContent = styled.div`
  color: #0b4684;
  text-align: center;
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  align-self: stretch;
  margin: 32px 0;
`
